import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RulesService } from '../services/rules/rules.service';
import { map, catchError } from 'rxjs/operators';
import { Rules } from '../interfaces/rules.interface';

@Injectable({
  providedIn: 'root'
})
export class RulesGuard implements CanActivate {

  constructor(
    private ruleService: RulesService,
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const cleanUrl = state.url.split('?')[0].split('#')[0].replace(/^\/+/, '');
    const id = this.ruleService.getFuncionalidade(cleanUrl);
    return this.checkRules(id);
  }


  protected checkRules(id: number): Observable<boolean> {
    return this.ruleService.check(id).pipe(
      map((actions: Rules) => {
        this.ruleService.access = actions;
        const accessGranted = this.getAccess();
        if (!accessGranted) {
          this.router.navigate(['/dashboard']);
        }
        return accessGranted;
      }),
      catchError((err) => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }

  protected getAccess(): boolean {
    const checker: boolean[] = [];
    const access = this.ruleService.access;
    for (const k in access) {
      if (Object.prototype.hasOwnProperty.call(access, k)) {
        const action = access[k];
        checker.push(action);
      }
    }
    return checker.includes(true);
  }

}
